<template>
  <v-card style="height: 100%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 31px;
        font-weight: bold;
        color: #05523e;
        padding-top: 30px;
      "
    >
      Edit Address
    </v-card-title>
    <div style="margin: 20px 8% auto">
      <div class="rows">
        <span>Address 1</span>
        <v-text-field class="textField" v-model="address1" outlined />
      </div>
      <div class="rows">
        <span>Address 2</span>
        <v-text-field class="textField" v-model="address2" outlined />
      </div>
      <div class="rows">
        <span>City</span>
        <v-text-field class="textField" v-model="city" outlined />
      </div>
      <div class="rows">
        <span>Zip Code</span>
        <v-text-field class="textField" v-model="zipCode" outlined />
      </div>
    </div>
    <v-card-actions style="justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="closeModal"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="editAddress"
        >Edit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { UPDATECUSTOMER } from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      address1: this.$store.state.account.customerOne.Address_1,
      address2: this.$store.state.account.customerOne.Address_2,
      city: this.$store.state.account.customerOne.City,
      zipCode: this.$store.state.account.customerOne.Zip_Code,
    };
  },
  methods: {
    async editAddress() {
      try {
        const req = {
          CustNum: this.$store.state.account.customerOne.custNum,
          Address_1: this.address1,
          Address_2: this.address2,
          City: this.city,
          Zip_Code: this.zipCode,
        };
        const updateResult = await runGqlMutation(UPDATECUSTOMER, req);
        if (
          updateResult.message === undefined &&
          updateResult.updateCustomer.ResultCount.length !== 0
        ) {
          await this.$emit("getCustomerOne");
          this.$store.commit("common/snackOn", {
            text: "Edit Address complete.",
          });
          this.closeModal();
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Edit Address Failed.",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async closeModal() {
      this.$store.commit("common/changeEditCustomerAddressModalView");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field .v-text-field--enclosed .v-text-field__details {
  margin: 0;
}
.v-input__slot {
  min-height: 20px;
}
.rows {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
.rows > span {
  width: 170px;
  font-size: 19px;
  font-weight: 500;
}
.textField {
  max-width: 170px;
  min-width: 170px;
}
</style>
